<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m11.99 2c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13h-1.5v6l5.25 3.15.75-1.23-4.5-2.67z"
    />
  </svg>
</template>
